import { useState, useContext, useEffect, useRef } from 'react';
import TextPargraph from '../utils/TextParagraph';
import Avis from './avis/Avis';
import { Rating } from 'react-simple-star-rating';
import { AppContext, UserContext } from '../../AppContextProvider';
import { BrowserView, MobileView } from 'react-device-detect';
import { useFetch } from '../api/FetchApiData';
import { MediaUrl } from '../utils/Media';
import { isMobile } from 'react-device-detect';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { useNavigate, useParams } from 'react-router-dom';
import SwitchButton from '../utils/ToggleSwitch';
import icon_rikinaze from '../icons/rikinaze.png';
import icon_delivery from '../icons/delivry.png';
import icon_cash from '../icons/cash_.png';
import icon_carte from '../icons/cartebleu.jpg';
import icon_paypal from '../icons/paypal.png';
import DatePicker from 'react-multi-date-picker';
import EventCalendar from '../utils/Calendar';

if (isMobile)
    import('./MobProduit.css').then(() => {});
else
    import('./produit.css').then(() => {});


export default function Produit({article_id})
{

    const [mainImage,setMainImage] = useState(null)
    const [UserState,setUserState] = useContext(UserContext);
    const fetchData = useFetch();
    const {id} = useParams();
    const navigator = useNavigate();
    const [article,setArticle] = useState({quantite:1,characteristics:[],images:[],is_kit:false,title:'',excluded_location_dates:[],description:'',info_tech:'',avis:[],price:'',stock:1,payment_modes:[],documents:[]});
    const [qteStatus, setQteStatus] = useState({color:'green',text:'en stock'});
    const [_DatePicker, setDatePicker] = useState(<DatePicker />);


    const LoadArticle = (id)=>{
        fetchData.GetData('articles/?id='+id).then((result)=>{
            console.log(result);
            if(result.result)
            {
                let qte = 1;
                let f = UserState.panier.articles.find((element) => element.article.id === result.article.id)
                if(f!==undefined)
                    qte = f.quantity;
                if(result.article.is_location)
                {
                    console.log(result.article.excluded_location_dates.map(d=>parse_date(d.date)));
                }
                setArticle({...result.article,payment_modes:JSON.parse(result.article.payment_modes),quantite:qte});
                if(result.article.images.length>0)
                    setMainImage(MediaUrl(result.article.images[0].image));
            }
        })
    }

    useEffect(()=>{
        //console.log(article);
    },[article])

    const parse_date=(datestr)=>{
        //const [d,m,y] = datestr.split("/").map(Number);
        return new Date(datestr);
    }

    useEffect(()=>{
        if(article.quantite > article.stock)
            setQteStatus({color:'orangered', text:'en stock, Approvisionnement le '+article.approvisionnement});
        else
            setQteStatus({color:'green', text:'en stock'});
    },[article.quantite])

    useEffect(()=>{
        if(!!id)
            LoadArticle(id);
        else
            navigator('/');
    },[])

    const ShowElementCompo = ()=>
    {
        if(article.is_kit)
        {
        return(
        <div>
            <h3>Composition : </h3>
            <div>
            {article.kit.map((art)=>{
                return(
                    <div className="CompoArticle" style={{borderRadius:'5px'}}>
                        <div className="CompoImage" style={{borderBottom:'1px solid lightgray',marginLeft:'0px'}}>
                            <div style={{position:'absolute',marginTop:'10px',backgroundColor:'rgba(0,0,0,0.5)',padding:'5px 10px 5px 5px',borderTopRightRadius:'5px',borderBottomRightRadius:'5px'}}>
                                <Rating size={23} initialValue={2.5} />
                            </div>
                            <img onClick={e=>{LoadArticle(art.article.id)}} alt='image' src={MediaUrl(art.article.image)} /> 
                        </div>
                        <div className="CompotTitle" style={{borderBottom:'1px solid lightgray'}}>
                            <label>{art.article.title}</label>
                        </div>
                        <div style={{width:'100%'}} className="CompotQty">
                            <label style={{maxWidth:'50%',display:'inline-block'}}>Quantité : </label>
                            <input type='number' style={{width:'30%',display:'inline-block'}} defaultValue={art.quantite} />
                        </div>
                </div>   
                )
            })}
            </div>
        </div>);}
        else{return}
    }

    const AddToPanier = ()=>
    {
            let _data = {}
            const found = UserState.panier.articles.find((element) => element.article.id === article.id);
            if(found!==undefined)
            {
                _data = {id:found.id, 
                    quantity:typeof(article.quantite)==='string' ? parseInt(article.quantite) : article.quantite,
                }
                if(article.is_location)
                {_data = {..._data,location_dates:article.location_dates};console.log(_data);}
                
            }
            else{
                _data = {article:{id:article.id},quantity:article.quantite};             
                if(article.is_location)
                {_data = {..._data,location_dates:article.location_dates}; }
                //_UserState.panier.articles.push(_art);
            }

            if(UserState.auth)
            {
                fetchData.PostData(_data,'panier/item/').then((result)=>
                    {
                        console.log(result);
                        if(result.result)
                        {
                            setUserState({...UserState,panier:result.panier}); 
                    }});
            }
            else
            {
                let _UserState = UserState;
                if(found!==undefined)
                {
                    let index = _UserState.panier.articles.indexOf(found);
                    found.quantity = typeof(found.quantity)==='string' ? parseInt(found.quantity)+1 : found.quantity+1;
                    found.article = {title:article.title,id:article.id,image:article.images.length>0?article.images[0].image:null};
                    if(article.is_location)
                        found['location_dates'] = article.location_dates
                    _UserState.panier.articles[index] = found;

                }
                else
                {
                    let _art = {article:{title:article.title,id:article.id,image:article.images.length>0?article.images[0].image:null},quantity:article.quantite};             
                    if(article.is_location)
                    {_art = {..._art,location_dates:article.location_dates}; }
                    _UserState.panier.articles.push(_art);
                }   
                setUserState({...UserState,panier:_UserState.panier});
            }
    }
    
    const ShowNewAvis = ()=>
    {
        const SendAvis = (avis)=>{
            delete avis.auther;
            avis = {...avis,article:Number(id)};
            console.log(avis);
            fetchData.PostData(avis,'avis/article/').then((result)=>{
                console.log(result);
            })
        }

        if(UserState.auth)
        {
            return(<Avis isNew={true} SendAvis={SendAvis} />);
        }
    }

    const BtnEdit = ()=>{
        if(UserState.is_staff)
            return(
                <div style={{width:'100%',marginBottom:'10px',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'row'}}>
                    <input onClick={e=>{navigator(`/add-product/${id}`)}} type='button' style={{height:'50px',padding:"5px 5px 5px 5px",width:'22%',backgroundColor:'skyblue',color:'black',border:'none',borderRadius:'5px',display:'inline-block',verticalAlign:'middle'}} value={"Modifier"} />
                    <button onClick={e=>{navigator(`/learning/article/${id}`)}} style={{background: "lightgray",verticalAlign:'middle',cursor: "pointer",margin:'5px',width:'48%',height:'50px',borderStyle:'none',borderRadius:'10px',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'row'}}>
                        <img src={icon_rikinaze} alt="Button Icon" style={{display:'inline-block',verticalAlign:'middle',width:"35px",height:"35px",borderRadius:'25px'}} />
                        <label style={{fontSize:'small',display:'inline-block',verticalAlign:'middle',marginLeft:'0px'}}>Que dois-je savoir?</label>
                    </button>
                    <div style={{width:'17%',marginLeft:'5px',display:'inline-block',verticalAlign:'middle',textAlign:'left'}}>
                        <label style={{fontSize:'medium',marginRight:'10px',display:'block',color:'gray',fontSize:'small'}}>Publié :</label>
                        <SwitchButton label="Produit Kit" checked={article.to_publish} onChange={checked=>{setArticle({...article,to_publish:checked})}} />
                    </div>
                </div>
            );
    }

    const Promo = ()=>
    {
        if(article.promo!==null && article.promo!==undefined)
        {
            let font = 'large';
            if(isMobile)
                font = 'small';
            return(
            <>
                <span style={{color:'red',fontWeight:'normal',fontSize:font}}>{article.promo.title} de -{article.promo.reduction} %
                    jusqu'au {article.promo.end}
                </span>
            </>)
        }
    }

    const PricesView = (withDelivery)=>{
        let prix = article.promo? (Number(article.price)-Number(article.price)*article.promo.reduction/100) : Number(article.price);
        let prixWithDeliv = Number(article.delivery_price)+prix;
        if(!withDelivery)
            return <><span style={{textDecoration:'line-through',marginRight:'10px'}}>{article.price} €</span><span style={{color:'red'}}>{prix.toFixed(2)} €</span></>
        else
            return <>{prixWithDeliv.toFixed(2)} €</>

    }

    const ex = [new Date(2025,9,10),new Date(2025,9,20),new Date(2025,9,21)];

    return(
        <div id='Produit'>
            <MobileView>
                {BtnEdit()}
            </MobileView>
            <div id='DivImages'>
                <BrowserView>
                    {BtnEdit()}
                </BrowserView>
                <MobileView>
                    <div id='title'>
                        <h1 style={{fontSize:'medium', color:'black'}}>{article.title}<br/>{Promo()}</h1>
                        <h2 className='infosBlock' id='Reference'><span style={{marginRight:'20px'}}> Reférence : {article.id}</span> 
                        <Rating iconsCount={5} initialValue={article.note} size={15} onClick={e=>{}} readonly={true}  onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} /> </h2>
                    </div>
                </MobileView>
                <div id='mainImage'>
                    <img style={{width:'100%',height:'100%'}} src={mainImage} />
                </div>
                {
                    article.images.map((image,index)=>
                    {
                        return <img key={index} onClick={e=>{setMainImage(MediaUrl(image.image))}} className='subImage' src={MediaUrl(image.image)} />;
                    }
                )}
            </div>
            <div id='ProduitInfos'>
                <BrowserView>
                    <div id='title'>
                        <h1 style={{marginBottom:'0px',color:'black'}}>{article.title}<br/>{Promo()}</h1>
                        <h2 style={{marginTop:'0px'}} className='infosBlock' id='Reference'>
                            <span style={{marginRight:'50px',fontSize:'large'}}> Reférence : {article.id} </span> 
                            <Rating size={30} initialValue={article.note} readonly={true} onClick={e=>{}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} /> 
                        </h2>
                    </div>
                     <div id='command' style={{width:"100%"}}>
                        <div id='stock' className='infosBlock'><label style={{backgroundColor:qteStatus.color}}>{article.stock} articles {qteStatus.text}</label></div>
                        <div style={{display:'flex', flexDirection:'row', alignItems:'center',justifyItems:'center'}} className='infosBlock'>
                            <div style={{width:"30%"}}>
                                <label>Quantité : </label>
                                <input style={{width:"30%",textAlign:'center'}} onChange={e=>{setArticle({...article,quantite:e.target.value})}} id='InputQuantity' value={article.quantite} step={1} type='number' />
                            </div>
                            { article.is_location && (
                            <div style={{width:"35%",display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <label>Dates : </label><DatePicker multiple
                                                           onChange={(dates)=>{setArticle({...article,location_dates:dates.map(d=>d.toString())})}}
                                                           minDate={new Date()}
                                                           style={{width:"70%",height:'30px',marginLeft:'5px',textAlign:'center'}}
                                                            mapDays={({date})=>{
                                                                let _dates = article.excluded_location_dates.map(d=>new Date(parse_date(d.date)));
                                                                const isExcluded = _dates.some((excluded)=> date.year===excluded.getFullYear() && date.month.number===excluded.getMonth()+1 && date.day===excluded.getDate());
                                                                return {disabled:isExcluded, style: isExcluded ? {backgroundColor:'#ffcfcf',color:'gray'} : {}};}}    
                                                            format='DD/MM/YYYY' placeholder='Vos dates' />
                            </div>)
                            }
                            <div style={{width:"30%"}}>
                                <input onClick={e=>{AddToPanier();}} id='btnCommand' type='button' value={'Commander'} />
                            </div>
                        </div>
                        <div id='DivDelivry' className='infosBlock'>
                            <span style={{color:'#581845'}}>
                                <img src={icon_delivery} style={{width:'30px',height:'30px',verticalAlign:'middle',marginRight:'20px'}} />
                                Livraison chez vous sous 3 jours depuis Moroni.
                            </span>
                        </div>
                    </div>
                </BrowserView>
                <MobileView>
                    <div id='command'>
                            <div className='infosBlock' style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <label >Quantité : </label>
                                <input style={{width:'15%',textAlign:'center',marginLeft:'10px'}} onChange={e=>{setArticle({...article,quantite:e.target.value})}} id='InputQuantity' defaultValue={1} step={1} type='number' />
                                <label style={{color:qteStatus.color}}>{article.stock} {qteStatus.text} </label>
                                { article.is_location && (
                                    <div style={{width:"40%",display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'15px'}}>
                                        <label style={{display:'block',width:'45%'}}>Dates : </label>
                                        <DatePicker multiple
                                                           onChange={(dates)=>{setArticle({...article,location_dates:dates.map(d=>d.toString())})}}
                                                           minDate={new Date()}
                                                           style={{width:"70%",height:'30px',marginLeft:'5px',textAlign:'center'}}
                                                            mapDays={({date})=>{
                                                                let _dates = article.excluded_location_dates.map(d=>new Date(parse_date(d.date)));
                                                                const isExcluded = _dates.some((excluded)=> date.year===excluded.getFullYear() && date.month.number===excluded.getMonth()+1 && date.day===excluded.getDate());
                                                                return {disabled:isExcluded, style: isExcluded ? {backgroundColor:'#ffcfcf',color:'gray'} : {}};}}    
                                                            format='DD/MM/YYYY' placeholder='Vos dates' />
                                    </div>)}
                            </div>
                            <div id='DivDelivry' className='infosBlock'>
                                <span style={{color:'#581845'}}>
                                    <img src={icon_delivery} style={{width:'30px',height:'30px',verticalAlign:'middle',marginRight:'20px'}} />
                                    Livraison chez vous sous 3 jours depuis Moroni.
                                </span>
                            </div>
                            <input onClick={e=>{AddToPanier();}} id='btnCommand' type='button' value={'Commander'} />
                        </div>
                </MobileView>
                <div id='paiement' className='infosBlock'>                    
                    <div id='price'>
                        <span style={{fontWeight:'bold'}}> Prix/unité : </span>
                        <hr/>
                        <div style={{display:'inline-block',color:'blue'}}>
                            <h2 style={{marginBottom:'3px',marginTop:'0px',fontSize:'large'}}>{PricesView(false)}</h2>
                            <span>Hors Livraison</span>
                        </div>
                        <div style={{color:'darkgray',display:'inline-block',float:'right'}}>
                            <h2 style={{marginBottom:'3px',marginTop:'3px',fontSize:'large',color:'black'}}>{PricesView(true)}</h2>
                            <span style={{color:'black'}}>Avec Livraison</span>
                        </div>
                    </div>
                    <div id='PaiementModes'>
                        <span style={{fontWeight:'bold'}}> Modes de paiement</span>
                        <hr/>
                        <div style={{textAlign:'center'}}>
                            {article.payment_modes.map((paiement,index)=>{
                                let src = "";
                                let width = "30px";
                                if(paiement==="Cash")
                                    src = icon_cash;
                                else if(paiement==='Carte Bancaire')
                                    src  = icon_carte;
                                else if(paiement==='Paypal')
                                {src  = icon_paypal;width="30px";}
        
                                return(<img key={index} src={src} style={{margin:'5px 15px 5px 5px',marginLeft:'0px',width:width}} />)
                            })}
                        </div>
                    </div>
                </div>
                <div id='description'>
                    <div>
                        <h3>Description : </h3>
                        <TextPargraph minlength={230} text={article.description} />
                    </div>
                    {ShowElementCompo()}
                    <Tabs>
                        <TabList>
                            <Tab>
                                <label style={{fontWeight:'bold'}}>Carateristiques</label>
                            </Tab>
                            <Tab>
                                <label style={{fontWeight:'bold'}}>Documents</label>
                            </Tab>
                            {
                                article.is_location && UserState.auth && UserState.is_staff && (                            
                                <Tab>
                                    <label style={{fontWeight:'bold'}}>Disponibilités</label>
                                </Tab>)
                            }
                        </TabList>
                        <TabPanel>
                            <div>
                                {
                                    article.characteristics.map((car,index)=>{
                                    return(
                                        <div key={index} className='CarRow'>
                                            <span className='CarName' style={{paddingLeft:'20px'}}>{car.name}</span>
                                            <span style={{float:'right',paddingRight:'30px'}} className='CarValue'>{car.value}</span>
                                            <hr style={{marginTop:'0px'}} />
                                        </div>);
                                    })
                                }
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div>
                                {
                                    article.documents.map((doc,index)=>{
                                        console.log(doc.title);
                                    return(
                                        <div className='FileDownload' key={index} onClick={e=>{window.open(MediaUrl(doc.document,"_blank"))}}>
                                            <div style={{textAlign:'left',paddingLeft:'10px'}}>
                                                <label style={{verticalAlign:'middle', color:'blue'}} className='CarName'>{doc.title.replace(".pdf","")}</label>
                                            </div>
                                            <hr style={{marginTop:'0px'}} />
                                        </div>);
                                        })
                                }
                            </div>
                        </TabPanel>
                        { article.is_location && UserState.auth && UserState.is_staff && (
                        <TabPanel style={{textAlign:'center',margin:'auto'}}>
                            <div style={{width:'85%',margin:'auto',textAlign:'center'}}>
                                <EventCalendar eventsData={article.excluded_location_dates} />
                            </div>
                        </TabPanel>)
                        }
                    </Tabs>
                    <div>
                        <h3>Autres informations : </h3>
                        <TextPargraph minlength={230} text={article.info_tech} />
                    </div>
                </div>
                <div id='avis' style={{marginBottom:'60px'}}>
                    <h3 style={{marginBottom:'0px'}}><span style={{marginRight:'20px'}}>Avis</span> 
                        <Rating size={20} initialValue={article.note}  readonly={true} onClick={e=>{}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} /> ({article.note}/5)</h3>
                    <hr style={{marginBottom:'20px'}}/>
                    {ShowNewAvis()}
                    {article.avis.map((avis)=>{
                        return <Avis isNew={false} avis={avis} />;
                    })}
                    
                </div>               
            </div>
        </div>
    )
}